<template>
  <div>
    <h4 class="mb-4 text-utel"><strong>Listado de Empresas</strong></h4>
    
    <v-data-table
      :headers="headers" 
      :items="companies" 
      item-key="id" 
      :page="currentPage"
      :items-per-page="itemsPerPage" 
      class="elevation-1 table text-center align-middle small" 
      :loading="loading"
      loading-text="Cargando..." 
      mobile-breakpoint="0" 
      :header-props="{ sortIcon: 'fa-solid fa-up-down' }"
      hide-default-footer
    >
      <template v-slot:item="{ item }">
        <tr class="text-center">
          <td>{{ item.id }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.users ? item.users.length : 0 }}</td>
          <td>
            <span :class="getStatusClass(item.hability)">
              {{ getStatusText(item.hability) }}
            </span>
          </td>
          <td>
            <button 
              type="button" 
              class="btn bg-utel-v2-secondary p-2 m-1 px-3 rounded-pill text-primary me-1" 
              title="Editar empresa" 
              @click="$emit('edit-company', item)"
            >
              <i class="fa-solid fa-edit"></i>
            </button>
            <button 
              type="button" 
              class="btn bg-utel-v2-secondary p-2 m-1 px-3 rounded-pill text-primary" 
              title="Eliminar empresa" 
              @click="$emit('delete-company', item)"
            >
              <i class="fa-solid fa-trash"></i>
            </button>
          </td>
        </tr>
      </template>
    </v-data-table>

    <simple-pagination 
      :current-page="currentPage"
      :page-count="pageCount"
      @page-change="handlePageChange"
    />
  </div>
</template>
<script>
import SimplePagination from '../users/SimplePagination.vue'

export default {
  name: 'CompanyTable',
  
  components: {
    SimplePagination
  },
  
  props: {
    companies: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    currentPage: { type: Number, default: 1 },
    pageCount: { type: Number, default: 1 },
    itemsPerPage: { type: Number, default: 10 }
  },
  
  emits: ['edit-company', 'delete-company', 'page-change'],
  
  computed: {
    headers() {
      return [
        { text: "#", value: "id", align: 'center' },
        { text: "Nombre", value: "name", align: 'center' },
        { text: "Usuarios inscritos", value: "users", align: 'center' },
        { text: "Estado", value: "hability", align: 'center' },
        { text: "Opciones", value: "actions", sortable: false }
      ]
    }
  },
  
  methods: {
    handlePageChange(page) {
      this.$emit('page-change', page);
    },
    
    getStatusClass(status) {
      return {
        'badge bg-success': status,
        'badge bg-danger': !status
      }
    },
    
    getStatusText(status) {
      return status ? 'Activo' : 'Inactivo'
    }
  }
}
</script>
<style scoped>
.text-utel {
  color: #1A0054;
}

.badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}
</style>
